import Vue from "vue";
import Router from "vue-router";
import interceptor from "./interceptor";
import axios from "axios";

/* vuex in store Module */
import { store } from "../js/store/store";

/* circleSLO */
import CircleSlo from "@/components/cowork/slo/CircleSlo";

/* hcpSSOLogin redirect */
import HcpSsoRedirect from "@/components/cowork/sso/hcp/hcpSsoRedirect";

/* hcpSSOIndex */
import HcpSsoIndex from "@/components/cowork/sso/hcp/hcpSsoIndex";

import Error from "@/components/cowork/Error";
//Vue.component("Error", Error);

import MyInfo from "@/components/cowork/common/myInfo/MyInfo";
//Vue.component("MyInfo", MyInfo);

import Intro from "@/components/cowork/general/intro/base/Intro";

/* Join(회원가입) */
import Join from "@/components/cowork/join/base/Join";
//Vue.component("Join", Join);

import ApprovalNoti from "@/components/cowork/join/base/ApprovalNoti";
//Vue.component("ApprovalNoti", ApprovalNoti);

/* Login(로그인) */
import Login from "@/components/cowork/login/Login";
//Vue.component("Login", Login);

/* ReLogin(세션로그인) */
import ReLogin from "@/components/cowork/login/ReLogin";
//Vue.component("ReLogin", ReLogin);

/* Index */
import Index from "@/components/cowork/Index";
Vue.component("Index", Index);

/* general Index(일반사용자 기본) */
import General from "@/components/cowork/general/Index";

/* cosys Index(시스템관리자 기본) */
import CoSys from "@/components/cowork/cosys/Index";

import HelpDesk from "@/components/cowork/common/helpDesk/HelpDesk";
import Appstore from "@/components/cowork/common/helpDesk/Appstore";
//Vue.component("General", General);

/* Main */
// import MainHeader from "@/components/cowork/general/main/MainHeader";
// Vue.component("MainHeader", MainHeader);

// import MainFooter from "@/components/cowork/general/main/MainFooter";
// Vue.component("MainFooter", MainFooter);

// import MainLeft from "@/components/cowork/general/main/MainLeft";
// Vue.component("MainLeft", MainLeft);

/* Project Home (일반사용자 과제 홈) */
import Project from "@/components/cowork/general/project/base/Project";

/* Cooperation */
import Cooperation from "@/components/cowork/general/cooperation/base/Cooperation";

/* Cooperation Manage  */
import CooperationManage from "@/components/cowork/general/cooperation/manage/CooperationManage";
import CooperationBoardManage from "@/components/cowork/general/cooperation/manage/CooperationBoardManage";

/* Project, Assignment, 과제, dashboard */
import Dashboard from "@/components/cowork/general/project/detail/Dashboard";
import Home from "@/components/cowork/general/home/base/Home";
import TodoNewPage from "@/components/cowork/general/main/modal/TodoPersonal";
import TodoBoardPopup from "@/components/cowork/general/main/modal/TodoPersonal";
import TodoTeam from "@/components/cowork/general/main/modal/TodoTeam";
import PerDeci from "@/components/cowork/general/project/modal/PerDeci";

/* ShareInfo */
import ShareInfo from "@/components/cowork/general/shareInfo/base/ShareInfo";

/* ShareInfo manage : 조성기 */
import ShareInfoManage from "@/components/cowork/general/shareInfo/manage/ShareInfoManage";
import ShareInfoBoardManage from "@/components/cowork/general/shareInfo/manage/ShareInfoBoardManage";

/* Noti 설정 */
import NotiSetting from "@/components/cowork/general/main/modal/ModifyNotiSetting";
import LanguageSetting from "@/components/cowork/general/main/modal/LanguageSetting";

/* Board */
import Board from "@/components/cowork/general/board/base/Board";
import BoardViewer from "@/components/cowork/general/board/base/BoardViewer";
/* Board Snapshot */
import BoardSnapshot from "@/components/cowork/general/board/base/BoardSnapshot";
/* Board Snapshot */
import DashboardSnapshot from "@/components/cowork/general/project/snapshot/DashboardSnapshot";
/* 피드백 요청하기 */
import ReqFeedbackModal from "@/components/cowork/general/board/modal/ReqFeedbackModal";
/* Viewer */
import Viewer from "@/components/cowork/general/file/viewer/Viewer";

/* 개인공간 */
import Mypage from "@/components/cowork/general/mypage/base/Mypage";
import Private from "@/components/cowork/general/mypage/private/base/Private";
import CooperationMemberBoard from "@/components/cowork/general/mypage/cooperationMember/CooperationMemberBoard";

/* SLO goSharePoint */
import GoSharePoint from "@/components/cowork/slo/GoSharePoint";

/* SLO goCircleOkr */
import GoCircleOkr from "@/components/cowork/slo/GoCircleOkr";

/* OKR */
import OkrMain from "@/components/cowork/general/okr/OkrMain";

/* treeSelect */
import treeselect from "@riophae/vue-treeselect";
Vue.component("treeselect", treeselect);

/* momentAgo(시간 계산) */
import momentAgo from "@/components/cowork/common/momentAgo/MomentAgo";
Vue.component("momentAgo", momentAgo);

/* Audit */
import Audit from "@/components/cowork/cosys/audit/base/Audit";
import FileDlpBlockList from "@/components/cowork/cosys/audit/base/tab/history/FileDlpBlockList";
import FileCopyList from "@/components/cowork/cosys/audit/base/tab/history/FileCopyList";
import FileDownloadList from "@/components/cowork/cosys/audit/base/tab/history/FileDownloadList";
import LoginList from "@/components/cowork/cosys/audit/base/tab/history/LoginList";
import CwExcept from "@/components/cowork/cosys/audit/base/tab/history/CwExcept";
import ProAndPrivateList from "@/components/cowork/cosys/audit/base/tab/history/ProAndPrivateList";
import ShareInfoSiteList from "@/components/cowork/cosys/audit/base/tab/history/ShareInfoSiteList";
import CfrcSiteList from "@/components/cowork/cosys/audit/base/tab/history/CfrcSiteList";
import CodeList from "@/components/cowork/cosys/audit/base/tab/history/CodeList";
import CwpoList from "@/components/cowork/cosys/audit/base/tab/history/CwpoList";
import HtagList from "@/components/cowork/cosys/audit/base/tab/history/HtagList";
import RoleList from "@/components/cowork/cosys/audit/base/tab/history/RoleList";
import RoleUserList from "@/components/cowork/cosys/audit/base/tab/history/RoleUserList";
import TodoDeptUser from "@/components/cowork/cosys/audit/base/tab/history/TodoDeptUser";
import UserList from "@/components/cowork/cosys/audit/base/tab/history/UserList";
import BatchList from "@/components/cowork/cosys/audit/base/tab/history/BatchList";
import MonitorObjectStat from "@/components/cowork/cosys/audit/base/tab/history/MonitorObjectStat";
import MonitorUserStat from "@/components/cowork/cosys/audit/base/tab/history/MonitorUserStat";
import MonitorProjectStat from "@/components/cowork/cosys/audit/base/tab/history/MonitorProjectStat";
import MonitorTodoStat from "@/components/cowork/cosys/audit/base/tab/history/MonitorTodoStat";
import MonitorCoworkUseStat from "@/components/cowork/cosys/audit/base/tab/history/MonitorCoworkUseStat";


/* 통계 관리 화면 추가 skyoon*/ 
import StatisticsManage from "@/components/cowork/cosys/audit/base/tab/history/StatisticsManage";

import MainTermsAndPolicy from "@/components/cowork/general/main/modal/MainTermsAndPolicy";

/* 피드백 파일 다운로드 : 김철환 */
import FeedbackFileDownload from "@/components/cowork/general/feedback/download/FeedbackFileDownload";

/* 하단 푸터 이용약관 윈도우 팝업 */
import FooterCotentModal from "@/components/cowork/general/main/modal/FooterCotentModal";

import requireAuth from "./authModule";
import isMgr from "./isMgrModule";
import { file } from "jszip/lib/object";
import { getPorts } from "portfinder";

Vue.use(Router);

export const router = new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      name: "index",
      component: Index,
      meta: {
        requiresAuth: true,
        basicLayout: true
      }
    },
    {
      path: "/error",
      name: "error",
      component: Error
    },
    {
      path: "*",
      component: Error
    },
    {
      path: "/login",
      name: "login",
      component: Login,
      meta: {
        basicLayout: true
      }
    },
    {
      path: "/circleSlo",
      name: "circleSlo",
      component: CircleSlo,
    },
    {
      path: "/reLogin",
      name: "reLogin",
      component: ReLogin,
      meta: {
        basicLayout: true
      }
    },
    {
      path: "/join",
      name: "join",
      component: Join,
      meta: {
        basicLayout: true
      }
    },
    {
      path: "/approvalNoti",
      name: "approvalNoti",
      component: ApprovalNoti,
      meta: {
        basicLayout: true
      }
    },
    {
      path: "/helpDesk",
      name: "helpDesk",
      component: HelpDesk
    },
    {
      path: "/terms/:type",
      name: "terms",
      component: FooterCotentModal
    },
    {
      path: "/appStore",
      name: "appStore",
      component: Appstore
    },
    {
      path: "/dashboardSnapshot/:groupId",
      name: "dashboardSnapshot",
      component: DashboardSnapshot,
      meta: {
        winpop: true,
        requiresAuth: true,
        basicLayout: true
      }
    },
    {
      path: "/boardSnapshot/:paperId",
      name: "boardSnapshot",
      component: BoardSnapshot,
      meta: {
        winpop: true,
        isBoard: true,
        requiresAuth: true,
        basicLayout: true
      }
    },
    {
      path: "/cosys",
      name: "cosys",
      component: CoSys,
      meta: { requiresAuth: true },
      children: [
        {
          path: "proAndPrivateList",
          name: "proAndPrivateList",
          component: ProAndPrivateList
        },
        {
          path: "shareInfoSiteList",
          name: "shareInfoSiteList",
          component: ShareInfoSiteList
        },
        {
          path: "cfrcSiteList",
          name: "cfrcSiteList",
          component: CfrcSiteList
        },

        {
          path: "fileDownload",
          name: "fileDownload",
          component: FileDownloadList
        },
        {
          path: "fileCopy",
          name: "fileCopy",
          component: FileCopyList
        },
        {
          path: "loginLog",
          name: "loginLog",
          component: LoginList
        },
        {
          path: "cwExcept",
          name: "cwExcept",
          component: CwExcept
        },
        {
          path: "fileDlpBlock",
          name: "fileDlpBlock",
          component: FileDlpBlockList
        },
        {
          path: "getCodeList",
          name: "getCodeList",
          component: CodeList
        },        
        {
          path: "getCwpoList",
          name: "getCwpoList",
          component: CwpoList
        },
        {
          path: "getHtagList",
          name: "getHtagList",
          component: HtagList
        },
        {
          path: "getRoleList",
          name: "getRoleList",
          component: RoleList
        },        
        {
          path: "getRoleUserList",
          name: "getRoleUserList",
          component: RoleUserList
        },
        {
          path: "getTdulList",
          name: "getTdulList",
          component: TodoDeptUser
        },
        {
          path: "getUserList",
          name: "getUserList",
          component: UserList
        },
        {
          path: "statisticsManage",
          name: "statisticsManage",
          component: StatisticsManage
        },
        {
          name: "getBatchList",
          path: "getBatchList",
          component: BatchList
        },
        {
          path: "monitorObjectStat",
          name: "monitorObjectStat",
          component: MonitorObjectStat
        },
        {
          path: "monitorUserStat",
          name: "monitorUserStat",
          component: MonitorUserStat 
        },
        {
          path: "monitorProjectStat",
          name: "monitorProjectStat",
          component: MonitorProjectStat 
        },
        {
          path: "monitorTodoStat",
          name: "monitorTodoStat",
          component: MonitorTodoStat 
        },
        {
          path: "monitorCoworkUseStat",
          name: "monitorCoworkUseStat",
          component: MonitorCoworkUseStat 
        },
      ]
    },
    {
      /* 일반 사용자 router */
      path: "/general",
      name: "general",
      component: General,
      meta: { requiresAuth: true },
      children: [
        {
          path: "intro",
          name: "intro",
          component: Intro
        },
        {
          path: "myInfo",
          name: "myInfo",
          component: MyInfo
        },
        {
          path: "home",
          name: "home",
          component: Home
        },
        {
          path: "project",
          name: "project",
          component: Project
        },
        {
          path: "cooperation",
          name: "cooperation",
          component: Cooperation
        },
        {
          path: "shareInfo",
          name: "shareInfo",
          component: ShareInfo
        },
        {
          path: "shareInfoManage",
          name: "shareInfoManage",
          component: ShareInfoManage
        },
        {
          path: "shareInfoBoardManage",
          name: "shareInfoBoardManage",
          component: ShareInfoBoardManage
        },
        {
          path: "cooperationManage",
          name: "cooperationManage",
          component: CooperationManage
        },
        {
          path: "cooperationBoardManage",
          name: "cooperationBoardManage",
          component: CooperationBoardManage
        },
        {
          path: "todoNewPage",
          name: "todoNewPage",
          meta: { basicLayout: true },
          component: TodoNewPage
        },
        {
          path: "TodoTeam",
          name: "TodoTeam",
          meta: { basicLayout: true },
          component: TodoTeam
        },
        {
          path: "todoBoardPopup/:paperId",
          name: "todoBoardPopup",
          meta: { basicLayout: true },
          component: TodoBoardPopup
        },
        {
          path: "perDeci",
          name: "perDeci",
          meta: { basicLayout: true },
          component: PerDeci
        },
        {
          path: "reqFeedbackModal/:paperId",
          name: "reqFeedbackModal",
          meta: {
            winpop: true,
            basicLayout: true
          },
          component: ReqFeedbackModal
        },
        {
          path: "board/:paperId",
          name: "board",
          component: Board,
          meta: {
            basicLayout: true
          }
        },
        {
          path: "board/:paperId/:paperProjectLinkId",
          name: "boardLink",
          component: Board,
          meta: {
            basicLayout: true
          }
        },
        {
          path: "boardTarget/:paperId/:blockId",
          name: "boardTargetBlock",
          component: Board,
          meta: {
            basicLayout: true
          }
        },
        {
          path: "boardTarget/:paperId/:blockId/:commentId",
          name: "boardTargetComment",
          component: Board,
          meta: {
            basicLayout: true
          }
        },
        {
          path: "boardViewer/:paperId",
          name: "boardViewer",
          component: BoardViewer,
          meta: {
            basicLayout: true
          }
        },
        {
          path: "dashboard/:projectId",
          name: "dashboard",
          component: Dashboard
        },
        {
          path: "myPage",
          name: "myPage",
          component: Mypage
        },
        {
          path: "private",
          name: "private",
          component: Private
        },
        {
          path: "cooperationMemberBoard",
          name: "cooperationMemberBoard",
          component: CooperationMemberBoard
        },
        {
          path: "viewer/:groupId/:fileId",
          name: "viewer",
          component: Viewer,
          meta: { basicLayout: true }
        },
        {
          path: "viewer/:groupId/:spSiteId/:spFolderId/:spFileId",
          name: "spViewer",
          component: Viewer,
          meta: { basicLayout: true }
        },
        {
          path: "okrMain",
          name: "okrMain",
          component: OkrMain,
          meta: { okrFooter: true }
        },
        {
          path: "okrMain/:type",
          name: "okrMain/:type",
          component: OkrMain,
          meta: { okrFooter: true }
        },
        {
          path: "notiSetting",
          name: "notiSetting",
          component: NotiSetting
        },
        {
          path: "languageSetting",
          name: "languageSetting",
          component: LanguageSetting
        },
        {
          path: "fileDownload/:groupId/:fileId",
          name: "feedbackFileDownload",
          component: FeedbackFileDownload,
          meta: { basicLayout: true }
        }
      ]
    },
    {
      path: "/slo/goSharePoint",
      name: "goSharePoint",
      component: GoSharePoint
    },
    {
      path: "/slo/goCircleOkr",
      name: "goCircleOkr",
      component: GoCircleOkr
    },
    {
      path: "/hcpsso/sso_login",
      name: "/hcpsso/sso_login",
      component: Login,
      meta: {
        basicLayout: true
      }
    },
    {
      path: "/hcpsso/sso_reLogin",
      name: "/hcpsso/sso_reLogin",
      component: ReLogin,
      meta: {
        basicLayout: true
      }
    },
    {
      path: "/hcpsso/hcpSsoRedirect/:userId",
      name: "hcpSsoRedirect",
      component: HcpSsoRedirect
    },
    {
      path: "/hcpsso/hcpSsoIndex",
      name: "hcpSsoIndex",
      component: HcpSsoIndex
    }
  ]
});
/*
  Vue NavigationGuard(라우터 내의 component 이동시 token 체크)
  to : 이동할 URL 정보가 담긴 라우터 객체
  from : 현재 URL 정보가 담긴 라우터 객체
  next : to 에서 지정한 URL 로 이동하기 위해 반드시 호출해야 하는 함수
*/
router.beforeEach(async (to, from, next) => {
  
  // 호출메일로 보드 이동시 해당 호출로 이동하기위한 데이터 localStorage 저장.
  if(to.params.blockId != null){
    localStorage.setItem("targetBlockId", to.params.blockId);
  }

  if(to.params.commentId != null){
    localStorage.setItem("targetCommentId", to.params.commentId);
  }

  let setReturnUrlsYn = false;
  let isLoggedIn = false;
  /* token 인증 모듈 동작 여부 분기
   * 최초 login 페이지에서 요청시 token 인증 모듈 동작 X
   * 타 페이지에서 요청시 token 인증 모듈 동작 O
   */

  /*  한화생명 SSO 로그인 시 /api/auth/hcpsso/sso_protect -> hcpSsoRedirect.vue 호출 */
  if(location.host.indexOf("hanwhalife") > -1 && location.host != "cpdev.hanwhalife.com" && from.path === "/" && to.path === "/"){
    next("/hcpsso/hcpSsoIndex");
  } else if (from.path != "/login" && from.path != "/circleSlo") {
    /* 
      router 내의 component 이동 시  일 경우
      - token 인증이 필요한 최상위 컴포넌트 값이 true   : token 인증 권한 체크 모듈 호출
      - token 인증이 필요한 최상위 컴포넌트 값이 false  : 요청 들어온 페이지로 이동 
    */
    if (to.matched[0].meta.requiresAuth) {
      let toPath = to.path;
      let seq = 0;
      if (
        toPath.indexOf("todoBoardPopup") !== -1 ||
        toPath.indexOf("todoProjectPopup") !== -1 ||
        toPath.indexOf("reqFeedbackModal") !== -1
      ) {
        seq++;
      }
      if (
        to.path !== "/general/todoNewPage" &&
        to.path !== "/general/TodoTeam" &&
        to.path !== "/general/perDeci" &&
        to.path !== "/general/reqFeedbackModal" &&
        seq === 0
      ) {
        if(to.path.indexOf("/general/viewer") > -1){
          // 보드 > 뷰어 > 뷰어 창 닫기 후 보드에서 뒤로가기가 되지 않아 주석
          //   localStorage.removeItem("returnUrl");
          //   localStorage.removeItem("returnUrls");
        } else {
          if(from.path.indexOf("/general/viewer") > -1){
            // 뷰어 X 버튼 클릭시 
            localStorage.setItem("returnUrl", to.path);
          } else if(to.path.indexOf("/general/home") != -1 ||
                    to.path.indexOf("/general/intro") != -1){
            if(from.path.indexOf("/general/dashboard") != -1 ||
               from.path.indexOf("/general/shareInfo") != -1 ||
               from.path.indexOf("/general/cooperation") != -1 ||
               from.path.indexOf("/general/myPage") != -1 ||
               from.path.indexOf("/general/myInfo") != -1 ||
               from.path.indexOf("/general/notiSetting") != -1 ||
               from.path.indexOf("/general/project") != -1){
              // 홈으로 이동하는 경우 
               localStorage.setItem("returnUrl", to.path);
            }else{
              setReturnUrlsYn = true;
            }           
          }else if(to.path.indexOf("/general/project") != -1){
            if(from.path.indexOf("/general/dashboard") != -1){
              // 과제에서 뒤로가기로 과제홈으로 접근하는 경우
              localStorage.setItem("returnUrl", to.path);
            }else{
              // 과제 이외의 좌측 메뉴를 통해 과제홈으로 접근하는 경우
              setReturnUrlsYn = true;
            }           
          }else if(to.path.indexOf("/general/cooperation") != -1){
            // 회의협의체 관련  
            if(from.path.indexOf("/general/cooperationManage") != -1 ||
               from.path.indexOf("/general/cooperationBoardManage") != -1){
              localStorage.setItem("returnUrl", to.path);
            }else{
              setReturnUrlsYn = true;
            }           
          }else if(to.path.indexOf("/general/shareInfo") != -1){
            // 정보공유 관련
            if(from.path.indexOf("/general/shareInfoManage") != -1 ||
               from.path.indexOf("/general/shareInfoBoardManage") != -1 ){
              localStorage.setItem("returnUrl", to.path);
            }else{
              setReturnUrlsYn = true;
            }           
          }else if(to.path.indexOf("/general/myPage") != -1){
            // 나의공간 관련
            if(from.path.indexOf("/general/cooperationMemberBoard") != -1 ||
               from.path.indexOf("/general/private") != -1 ){
              localStorage.setItem("returnUrl", to.path);
            }else{
              setReturnUrlsYn = true;
            }           
          } else{
            setReturnUrlsYn = true;
          }
        }

        // localStorage.returnUrls 수정.
        if(setReturnUrlsYn){
          // console.log( from.path, " -> ", to.path);
          localStorage.setItem("returnUrl", to.path);
          let urlArray = [];
          if(localStorage.getItem("returnUrls") != null &&
             localStorage.getItem("returnUrls") != ""){
               urlArray = localStorage.getItem("returnUrls").split(",");
          }
          // urlArray.push(localStorage.getItem("returnUrls"));
          if (urlArray.length < 11) {
            urlArray.push(to.path);
            localStorage.setItem("returnUrls", urlArray);
          } else {
            urlArray.shift();
            urlArray.push(to.path);
            localStorage.setItem("returnUrls", urlArray);
          }
        }
      }
      let Authorization = localStorage.getItem("Authorization");
      
      if (Authorization !== null && Authorization !== undefined) {
        isLoggedIn = await requireAuth(to.path);
        if (isLoggedIn) {
          next();
        } else {
          if (
            to.path !== "/general/todoNewPage" &&
            to.path !== "/general/TodoTeam" &&
            to.path !== "/general/perDeci" &&
            to.path !== "/general/reqFeedbackModal" &&
            seq === 0
          ) {
            localStorage.setItem("returnUrl", to.path);
          }
        }
      } else {
        if (
          to.path !== "/general/todoNewPage" &&
          to.path !== "/general/TodoTeam" &&
          to.path !== "/general/perDeci" &&
          to.path !== "/general/reqFeedbackModal" &&
          seq === 0
        ) {
          localStorage.setItem("returnUrl", to.path);
        }
        next("/login");
      }
    } else {
      next();
    }
  } else {
    localStorage.removeItem("returnUrl");
    localStorage.removeItem("returnUrls");
    // 소켓 해제 
    store.commit('mySocket/setSocketDisConnect', {userId:localStorage.getItem("userId")});
    next();
  }
});



// WEBPACK FOOTER //
// ./src/router/index.js